import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function () {
  const parallaxContainers = document.querySelectorAll(".parallax-container");

  parallaxContainers.forEach((container, index) => {
    const config = {
      originalHorizontalWrapperScroll: -203,
      wrapper: {
        class: ".wrapper-horizontal",
        end: {
          mobile: "+=2500vh",
          medium: "+=2500vh",
          desktop: "+=2250vh",
          large: "+=2500vh",
        },
      },
      horizontalCards: [
        {
          id: "#horizontal-1",
          endTranslateX: {
            mobile: -90,
            medium: -90,
            desktop: -150,
            large: -150,
          },
          end: {
            mobile: "+=3000vh",
            medium: "+=2200vh",
            desktop: "+=2100vh",
            large: "+=2100vh",
          },
        },
        {
          id: "#horizontal-2",
          endTranslateX: {
            mobile: -150,
            medium: -150,
            desktop: -125,
            large: -125,
          },
          end: {
            mobile: "+=3500vh",
            medium: "+=4800vh",
            desktop: "+=2000vh",
            large: "+=2000vh",
          },
        },
        ,
        {
          id: "#horizontal-2_5",
          endTranslateX: {
            mobile: -120,
            medium: -150,
            desktop: -100,
            large: -100,
          },
          end: {
            mobile: "+=3500vh",
            medium: "+=4800vh",
            desktop: "+=2000vh",
            large: "+=2000vh",
          },
        },
        {
          id: "#horizontal-3",
          endTranslateX: {
            mobile: -50,
            medium: -50,
            desktop: -50,
            large: -50,
          },
          end: {
            mobile: "+=3300vh",
            medium: "+=4000vh",
            desktop: "+=4000vh",
            large: "+=4000vh",
          },
        },
        {
          id: "#horizontal-4",
          endTranslateX: {
            mobile: -50,
            medium: -50,
            desktop: -100,
            large: -100,
          },
          end: {
            mobile: "+=3500vh",
            medium: "+=4000vh",
            desktop: "+=4000vh",
            large: "+=4000vh",
          },
        },
      ],
      verticalCards: [
        {
          id: "#vertical-1",
          endTranslateY: {
            mobile: -100,
            medium: -100,
            desktop: -150,
            large: -150,
          },
          end: {
            mobile: "+=2000vh",
            medium: "+=2000vh",
            desktop: "+=2000vh",
            large: "+=2000vh",
          },
        },
        {
          id: "#vertical-2",
          endTranslateY: {
            mobile: -100,
            medium: -100,
            desktop: -100,
            large: -100,
          },
          end: {
            mobile: "+=1200vh",
            medium: "+=1500vh",
            desktop: "+=1000vh",
            large: "+=1000vh",
          },
        },
        {
          id: "#vertical-3",
          endTranslateY: {
            mobile: -175,
            medium: -175,
            desktop: -250,
            large: -250,
          },
          end: {
            mobile: "+=2000vh",
            medium: "+=2000vh",
            desktop: "+=2000vh",
            large: "+=2500vh",
          },
        },
      ],
    };

    // Function to get current device type
    function getDeviceType() {
      const width = window.innerWidth;
      if (width <= 500) return "mobile";
      if (width <= 1400) return "medium";
      if (width <= 1920) return "desktop";
      return "large";
    }

    // Main horizontal scroll trigger for this container
    ScrollTrigger.create({
      trigger: container,
      start: "top top",
      end: () => {
        const deviceType = getDeviceType();
        return config.wrapper.end[deviceType];
      },
      scrub: 0.5,
      pin: true,
      anticipatePin: 0.5,
      invalidateOnRefresh: true,
      fastScrollEnd: 3000,
      preventOverlaps: `group${index}`,
      touch: true,
      forceRefresh: true,
      normalizeScroll: true,
      onUpdate: (self) => {
        const wrapperElement = container.querySelector(config.wrapper.class);
        gsap.to(wrapperElement, {
          x: () =>
            `${config.originalHorizontalWrapperScroll * self.progress}vw`,
          duration: 0,
          ease: "power3.inOut",
        });
      },
    });

    // Horizontal cards animation for this container
    config.horizontalCards.forEach((card) => {
      ScrollTrigger.create({
        trigger: container.querySelector(config.wrapper.class),
        start: "top top",
        end: () => {
          const deviceType = getDeviceType();
          return card.end[deviceType];
        },
        scrub: 1,
        invalidateOnRefresh: true,
        preventOverlaps: `group${index}`,
        onUpdate: (self) => {
          const deviceType = getDeviceType();
          const cardElement = container.querySelector(card.id);
          gsap.to(cardElement, {
            x: () => `${card.endTranslateX[deviceType] * self.progress}%`,
            duration: 0.5,
            ease: "power3.Out",
          });
        },
      });
    });

    // Vertical card scroll animation for this container
    config.verticalCards.forEach((card) => {
      ScrollTrigger.create({
        trigger: container.querySelector(config.wrapper.class),
        start: "top top",
        end: () => {
          const deviceType = getDeviceType();
          return card.end[deviceType];
        },
        scrub: 1,
        invalidateOnRefresh: true,
        preventOverlaps: `group${index}`,
        onUpdate: (self) => {
          const deviceType = getDeviceType();
          const cardElement = container.querySelector(card.id);
          gsap.to(cardElement, {
            y: () => `${card.endTranslateY[deviceType] * self.progress}%`,
            duration: 0.3,
            ease: "power3.out",
          });
        },
      });
    });
  });
});
